/* eslint-disable max-len */
import CollectionName from './collections';

const pathPlaceholder = {
  COACH_ID: 'coachId',
  USER_ID: 'userId',
  PRODUCT_ID: 'productId',
  MEAL_PLAN_TEMPLATE_ID: 'mealPlanTemplateId',
  PROGRAM_ID: 'programId',
  TRACK_ID: 'trackId',
  WORKOUT_ID: 'workoutId',
  COACH_CONFIG_ID: 'coachConfigId',
  ROLE_ID: 'roleID',
  ANNOUNCEMENT_ID: 'announcementId',
  ANNOUNCEMENT_COMMENT_ID: 'announcementCommentId',
};

const firestorePaths = {
  COACH_ASSIGNMENT_COLLECTION: `/${CollectionName.COACH_ASSIGNMENT}`,
  COACH_COLLECTION: `/${CollectionName.COACH}`,
  INTEGRATIONS: `/${CollectionName.INTEGRATIONS}`,
  USER: `/${CollectionName.USER}`,
  TAG: `/${CollectionName.TAG}`,
  CONFIG: `/${CollectionName.CONFIG}`,
  CLIENT_SMS: `/${CollectionName.CLIENT_SMS}`,
  PUBLIC_DOCUMENT: '/app/public',
  WORKOUT: `/${CollectionName.WORKOUT}`,
  WORKOUT_ASSIGNMENT: `/${CollectionName.WORKOUT_ASSIGNMENT}`,
  PRODUCT: `/${CollectionName.PRODUCT}`,
  WEB_CUSTOMIZATION: '/webCustomization',
  MEAL_PLAN: `/${CollectionName.MEAL_PLAN}`,
  MEAL_PLAN_ASSIGNMENT: `/${CollectionName.MEAL_PLAN_ASSIGNMENT}`,
  LEADS: `/${CollectionName.LEADS}`,
  LEAD_CAMPAIGN: `/${CollectionName.LEAD_CAMPAIGN}`,
  LEAD_CAMPAIGN_MSGS: `/${CollectionName.LEAD_CAMPAIGN_MSGS}`,
  LEAD_REENGAGEMENT_SEQUENCES: `/${CollectionName.LEAD_REENGAGEMENT_SEQUENCES}`,
  BROADCAST_MESSAGE: `/${CollectionName.BROADCAST_MESSAGE}`,
  BROADCAST_MESSAGE_REQUEST: `/${CollectionName.BROADCAST_MESSAGE_REQUEST}`,
  NUTRITION_PLAN: `/${CollectionName.NUTRITION_PLAN}`,
  NUTRITION_PLAN_REQUEST: `/${CollectionName.NUTRITION_PLAN_REQUEST}`,
  COACH_ONBOARDING: `/${CollectionName.COACH_ONBOARDING}`,
  COUPON: `/${CollectionName.COUPON}`,
  APP_CUSTOMIZATION: `/${CollectionName.APP_CUSTOMIZATION}`,
  INGREDIENT: `/${CollectionName.INGREDIENT}`,
  RECIPE: `/${CollectionName.RECIPE}`,
  MSG_TEMPLATES: `/${CollectionName.MSG_TEMPLATES}`,
  EMAIL_TEMPLATES: `/${CollectionName.EMAIL_TEMPLATES}`,
  COACH_INFO: `/${CollectionName.COACH_INFO}`,
  PROMOTIONS: `/${CollectionName.PROMOTIONS}`,
  COACH_REMINDER_NOTIFICATION: `/${CollectionName.COACH_REMINDER_NOTIFICATION}`,
  INTERNAL_ASSIGNMENT: `/${CollectionName.INTERNAL_ASSIGNMENT}`,
  METABASE_DASHBOARD: `/${CollectionName.METABASE_DASHBOARD}`,
  MSG_ENDPOINT: `/${CollectionName.MSG_ENDPOINT}`,
  PROGRAM: `/${CollectionName.PROGRAM}`,
  TRACK: `/${CollectionName.TRACK}`,
  TRACK_ASSIGNMENT: `/${CollectionName.TRACK_ASSIGNMENT}`,
  SCHEDULED_ASSIGNMENT: `/${CollectionName.SCHEDULED_ASSIGNMENT}`,
  COACH_CONFIG: `/${CollectionName.COACH_CONFIG}`,
  APP_CUSTOM_THEME: `/${CollectionName.APP_CUSTOM_THEME}`,
  GAMEPLAY_SESSION: `/${CollectionName.GAMEPLAY_SESSION}`,
  CHAT_CHANNEL: `/${CollectionName.CHAT_CHANNEL}`,
  CHAT_MESSAGE_REQUEST: `/${CollectionName.CHAT_MESSAGE_REQUEST}`,
  USER_CLAIMS: `/${CollectionName.USER_CLAIMS}`,
  ROLES: `/${CollectionName.ROLE}`,
  COACH_VOICE: `/${CollectionName.COACH_VOICE}`,
  COACH_POD: `/${CollectionName.COACH_POD}`,
  ANNOUNCEMENT: `/${CollectionName.ANNOUNCEMENT}`,
  CHECK_IN_THEMES: `/${CollectionName.CHECK_IN_THEMES}`,
  WORKOUT_REQUEST: `/${CollectionName.WORKOUT_REQUEST}`,
  WORKOUT_PICKS: `/${CollectionName.WORKOUT_PICKS}`,
};

firestorePaths
  .ONBOARDING_QUESTION_SEQUENCE_COLLECTION = `${firestorePaths.PUBLIC_DOCUMENT}/onboardingQuestionSequence`;
firestorePaths.ONBOARDING_QUESTION_COLLECTION = `${firestorePaths.PUBLIC_DOCUMENT}/onboardingQuestion`;

firestorePaths.COACH_DOC = `${firestorePaths.COACH_COLLECTION}/{${pathPlaceholder.COACH_ID}}`;
firestorePaths.USER_DOC = `${firestorePaths.USER}/{${pathPlaceholder.USER_ID}}`;
firestorePaths.COACH_CONFIG_DOC = `${firestorePaths.COACH_CONFIG}/{${pathPlaceholder.COACH_CONFIG_ID}}`;
firestorePaths.USER_CONFIG_DOC = `${firestorePaths.CONFIG}/{${pathPlaceholder.USER_ID}}`;
firestorePaths.USER_CLAIMS_DOC = `${firestorePaths.USER_CLAIMS}/{${pathPlaceholder.USER_ID}}`;
firestorePaths.ROLE_DOC = `${firestorePaths.ROLES}/{${pathPlaceholder.ROLE_ID}}`;

// Stripe Integration
firestorePaths.STRIPE = `${firestorePaths.INTEGRATIONS}/stripe`;
firestorePaths.STRIPE_PRODUCTS = `${firestorePaths.STRIPE}/products`;
firestorePaths.STRIPE_SUBSCRIPTIONS = `${firestorePaths.STRIPE}/subscriptions`;

// Facebook Integration
firestorePaths.FACEBOOK = `${firestorePaths.INTEGRATIONS}/facebook`;
firestorePaths.FACEBOOK_PIXEL_CONFIG = `${firestorePaths.FACEBOOK}/pixelConfig`;

// Suggestic
firestorePaths.SUGGESTIC = `${firestorePaths.INTEGRATIONS}/suggestic`;
firestorePaths.SUGGESTIC_RECIPE = `${firestorePaths.SUGGESTIC}/recipe`;

// Msg templates
firestorePaths.DEFAULT_MSG_TEMPLATES = `${firestorePaths.MSG_TEMPLATES}/defaultMsgs`;
firestorePaths.COACH_MSG_TEMPLATES = `${firestorePaths.MSG_TEMPLATES}/{${pathPlaceholder.COACH_ID}}`;
firestorePaths.PROGRAM_DOC = `${firestorePaths.PROGRAM}/{${pathPlaceholder.PROGRAM_ID}}`;
firestorePaths.TRACK_DOC = `${firestorePaths.TRACK}/{${pathPlaceholder.TRACK_ID}}`;
firestorePaths.WORKOUT_DOC = `${firestorePaths.WORKOUT}/{${pathPlaceholder.WORKOUT_ID}}`;

firestorePaths.DEFAULT_EMAIL_TEMPLATES = `${firestorePaths.EMAIL_TEMPLATES}/defaultEmails`;
firestorePaths.COACH_EMAIL_TEMPLATES = `${firestorePaths.EMAIL_TEMPLATES}/{${pathPlaceholder.COACH_ID}}`;

// Coach info
firestorePaths.COACH_INFO_DOC = `${firestorePaths.COACH_INFO}/{${pathPlaceholder.COACH_ID}}`;

// Announcement comments
firestorePaths.ANNOUNCEMENT_COMMENT = `${firestorePaths.ANNOUNCEMENT}/{${pathPlaceholder.ANNOUNCEMENT_ID}}/announcementComment`;
firestorePaths.ANNOUNCEMENT_COMMENT_REPORT = `${firestorePaths.ANNOUNCEMENT}/{${pathPlaceholder.ANNOUNCEMENT_ID}}/announcementComment/{${pathPlaceholder.ANNOUNCEMENT_COMMENT_ID}}/announcementCommentReport`;
firestorePaths
  .ANNOUNCEMENT_COMMENT_INTERACTION = `${firestorePaths.ANNOUNCEMENT_COMMENT}/{${pathPlaceholder.ANNOUNCEMENT_COMMENT_ID}}/announcementCommentInteraction`;
firestorePaths.ANNOUNCEMENT_USER_INTERACTION = `${firestorePaths.ANNOUNCEMENT}/{${pathPlaceholder.ANNOUNCEMENT_ID}}/userInteraction`;

// Promotions
firestorePaths.COACH_PROMOTIONS = `${firestorePaths.PROMOTIONS}/{${pathPlaceholder.COACH_ID}}`;

firestorePaths.WORKOUT_PICKS_DOC = `${firestorePaths.WORKOUT_PICKS}/{${pathPlaceholder.COACH_ID}}`;

const realTimeDBPaths = {
  USER_STATUS: '/userStatus',
};

realTimeDBPaths.USER_STATUS_DOC = `${realTimeDBPaths.USER_STATUS}/{${pathPlaceholder.USER_ID}}`;

export {
  firestorePaths,
  pathPlaceholder,
  realTimeDBPaths,
};
